module.exports = __webpack_public_path__ + "static/media/icon-list.5edf8fde.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/personalization/images/icon-list.png
// module id = 2923
// module chunks = 0